import React, { useEffect, useState } from 'react';
import { TextField, FormControl, InputLabel, Grid, Paper, Select, MenuItem, useMediaQuery, Button, FormHelperText, CircularProgress } from '@mui/material';
import styled, { inputImages, inputStyles } from '../../Utils/inputChanges';
import Titlebar from '../TitleBar';
import { useDispatch, useSelector } from 'react-redux';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import { errorStyles } from '../../Utils/table';
import { fetchPannaData } from '../../Store/PHPSlice/Panna';
import DropdownWithBtn from '../FieldsComponents/DropdownWithBtn';
import { Items } from '../TitleList';
import { insertPatternMatching } from '../../Store/PHPSlice/Pattern/PatternMatching';


const PatternMatching = ({ data }) => {
    const userdata = JSON.parse(localStorage.getItem('user'));
    const [formData, setFormData] = useState({
        firmId: "",
        userId: userdata?.ID
    });
    const [errors, setErrors] = useState({});

    const [openDropdowns, setOpenDropdowns] = useState({});
    const [loading, setLoading] = useState(false);
    const actionMap = {
        panna: fetchPannaData
        // Add more mappings if needed
    };

    const isDesktop = useMediaQuery('(min-width:768px)'); // Adjust the breakpoint as per your requirement
    const dispatch = useDispatch();
    const getPanas = useSelector((state) => state.PannaData.pana || { data: [] });
    useEffect(() => {
        dispatch(fetchPannaData());
        Object.keys(openDropdowns).forEach((dropdown) => {
            if (openDropdowns[dropdown]) {
                const action = actionMap[dropdown];
                if (action) {
                    dispatch(action());
                }
            }
        });
    }, [openDropdowns, dispatch]);

    if (!getPanas) {
        return <h1>Loading...</h1>
    }
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value.toUpperCase()
        });
    };
    const handleImageChange = (e) => {
        setFormData({
            ...formData,
            clothImg: e.target.files[0]
        });
    };
    const handleDropdownChange = (e, dropdownType) => {
        const { value } = e.target;
        setFormData({
            ...formData,
            [dropdownType]: value
        });
    };


    const handleDropdownOpen = (dropdown) => {
        setOpenDropdowns((prev) => ({ ...prev, [dropdown]: true }));
    };

    const handleDropdownClose = (dropdown) => {
        setOpenDropdowns((prev) => ({ ...prev, [dropdown]: false }));
    };



    const handleSubmit = async (e) => {
        e.preventDefault();

        if (formData.patMatch === "") {
            alert('enter Pattern Name.')
        }

        if (formData.panna === "") {
            alert('Select Panna');
        }

        if (formData.avg === "") {
            alert('enter Pattern Avg.')
        }


        setLoading(true);

        try {

            const result = await dispatch(insertPatternMatching(formData)).unwrap();
            console.log('POST request successful!', result);
            // toast.success("Item Added");
            alert("Pattern Matching Added");
            if (data === '1') {
                window.close();
            } else {
                window.location.reload();
            }
        } catch (error) {
            console.error('Error while making POST request:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleNavigatePanna = () => {
        window.open(`/new-panna-entry`, '_blank', 'width=800,height=600,scrollbars=yes,resizable=yes');
    };

    const uomlist = [
        { ID: 'm', value: 'm' },
        { ID: 'kg', value: 'kg' }
    ];

    const dropdownPanna = [
        {
            label: 'Panna',
            id: 'panna',
            options: getPanas?.data || [],
            value: formData.panna,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'panna', value: newValue ? newValue.panna_size : '' } }, 'panna'),
            getOptionLabel: (option) => option.panna_size || '',
            isOptionEqualToValue: (option, value) => option.panna_size === value.panna_size,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.panna_size === value) || null;
                }
                return null;
            },
            handleAddNew: () => handleNavigatePanna(),
            btnlabel: 'New',
            handleDropdownOpen: () => handleDropdownOpen('panna'),
            handleDropdownClose: () => handleDropdownClose('panna'),
            errors: errors.panna
        },
        // {
        //     label: 'UOM',
        //     id: 'uom',
        //     options: uomlist || [],
        //     value: formData.uom,
        //     onChange: (newValue) => handleDropdownChange({ target: { name: 'uom', value: newValue ? newValue.ID : '' } }, 'uom'),
        //     getOptionLabel: (option) => option.value || '',
        //     isOptionEqualToValue: (option, value) => option.ID === value.ID,
        //     valueFinder: (options, value) => {
        //         if (Array.isArray(options)) {
        //             return options.find(item => item.ID === value) || null;
        //         }
        //         return null;
        //     },
        // }
    ];




    return (
        <>

            {data === '1' ? null : <Titlebar data={Items} />}
            <div style={{ margin: '1% 0.5%' }}>
                <h2>Pattern Matching Entry</h2>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '2vh' }}>
                            <Grid container spacing={0.5}>


                                {[
                                    { label: 'Pattern Name', name: 'patMatch' },
                                    { label: 'In Marathi', name: 'marathi' },

                                ].map((field, index) => (
                                    <Grid item xs={12} md={6} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name} >{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth error={!!errors[field.name]}>
                                                    {field.type === 'file' ? (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            type="file"
                                                            onChange={handleImageChange}
                                                            inputProps={{ style: styled.inputImg }}
                                                            sx={inputImages}
                                                        />
                                                    ) : (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            value={formData[field.name]}
                                                            onChange={handleInputChange}
                                                            inputProps={{ style: styled.input }}
                                                            sx={inputStyles}
                                                        />
                                                    )}
                                                    {errors[field.name] && <FormHelperText style={errorStyles}>{errors[field.name]}</FormHelperText>}
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}

                                {/* Panna dropdown */}



                                {dropdownPanna?.map((drop) => (
                                    <DropdownWithBtn
                                        key={drop.label}
                                        label={drop.label}
                                        id={drop.id}
                                        options={drop.options}
                                        value={drop.value}
                                        onChange={drop.onChange}
                                        isDesktop={isDesktop}
                                        getOptionLabel={drop.getOptionLabel}
                                        isOptionEqualToValue={drop.isOptionEqualToValue}
                                        valueFinder={drop.valueFinder}  // Pass `valueFinder` function here
                                        handleAddNew={drop.handleAddNew}
                                        btnlabel={drop.btnlabel}
                                        handleDropdownOpen={drop.handleDropdownOpen}
                                        handleDropdownClose={drop.handleDropdownClose}
                                        errors={drop.errors}
                                    />
                                ))
                                }


                                {[


                                    { label: 'Avg', name: 'avg' },

                                ].map((field, index) => (
                                    <Grid item xs={12} md={6} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name} >{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth error={!!errors[field.name]}>
                                                    {field.type === 'file' ? (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            type="file"
                                                            onChange={handleImageChange}
                                                            inputProps={{ style: styled.inputImg }}
                                                            sx={inputImages}
                                                        />
                                                    ) : (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            value={formData[field.name]}
                                                            onChange={handleInputChange}
                                                            inputProps={{ style: styled.input }}
                                                            sx={inputStyles}
                                                            InputProps={field.name === 'uom' ? { readOnly: true } : {}}
                                                        />
                                                    )}
                                                    {errors[field.name] && <FormHelperText style={errorStyles}>{errors[field.name]}</FormHelperText>}
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}

                                <Grid item xs={12} textAlign="center">
                                    <Button variant="contained" color="primary" onClick={handleSubmit} disabled={loading === true}>
                                        {
                                            loading === true ?
                                                <><CircularProgress size="20px" /> wait...</> :
                                                "Submit"
                                        }
                                    </Button>
                                </Grid>
                            </Grid>
                            <ToastContainer />
                        </Paper>
                    </Grid>
                </Grid>
            </div>
        </>
    );
}

export default PatternMatching;